module.exports = __webpack_public_path__ + "static/Quaggoth-c9f2f7662df2352978130a4d7e3005c5.jpg";